import { Webhook, Endpoint } from '@square/ignition';
import { ReferenceHrefBuilders } from '@squareup/dex-tech-utils-routing';
import { Box, Heading20 } from '@squareup/dex-ui-shared-base';
import { toWebhookPathParam } from '@squareup/dex-utils-oas';
import { Params, useParams } from '@squareup/dex-utils-shared-routing-hooks';
import React from 'react';

import { ReferenceItem } from '../../ReferenceItem';

import styles from './endpoints-webhook-card-list.module.css';

const getItemData = (item: Endpoint | Webhook) => {
  // `item` contains getters which cannot be spread, so instead,
  // required properties are explicitly specified
  if (item instanceof Endpoint) {
    return {
      description: item.description?.split('. ', 1)[0],
      httpMethod: item.httpMethod,
      isBeta: item.isBeta,
      isDeprecated: item.isDeprecated,
      isV1: item.isV1,
      path: item.path,
      summary: item.summary,
      title: item.name,
    };
  }

  return {
    description: item.description?.split('. ', 1)[0],
    isBeta: item.isBeta,
    isDeprecated: item.isDeprecated,
    isV1: item.isV1,
    title: item.name,
  };
};

const RefItems = ({
  items,
  query,
}: {
  items: Webhook[] | Endpoint[];
  query: Params;
}) => {
  const square_version = query?.square_version as string;

  return (
    <>
      {items.map((item) => {
        if (!item?.api || !item) {
          return <>Undefined API</>;
        }

        let href;

        if (item instanceof Endpoint) {
          href = ReferenceHrefBuilders.versionApiEndpoint({
            endpoint: item.id,
            api: `${item?.api?.id}-api`,
            square_version,
          });
        } else if (item instanceof Webhook) {
          href = ReferenceHrefBuilders.versionApiWebhook({
            webhook: toWebhookPathParam(item),
            api: `${item?.api?.id}-api`,
            square_version,
          });
        }
        return (
          <ReferenceItem
            key={item.id}
            subItems={[
              {
                item: getItemData(item),
                className: styles['reference-item'],
                as: 'li',
                key: item.id,
                href,
              },
            ]}
          />
        );
      })}
    </>
  );
};

const EndpointsWebhookCardList = ({
  categoriesWebhooksMap,
  setListRef,
}: {
  categoriesWebhooksMap: Map<string, Webhook[]>;
  setListRef: (ref: HTMLElement | null) => void;
}) => {
  const query = useParams();

  return (
    <div ref={setListRef}>
      {[...categoriesWebhooksMap.keys()].map((api) => {
        const webhooks = categoriesWebhooksMap.get(api);
        return webhooks ? (
          <div key={api}>
            <Box margin={{ top: '3x' }}>
              <Heading20>{api}</Heading20>
              <ul key={api}>
                <RefItems items={webhooks} query={query} />
              </ul>
            </Box>
          </div>
        ) : null;
      })}
    </div>
  );
};

export { EndpointsWebhookCardList };
